import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";

import { Content } from "@/features/dashboard/pedidos/$id/components/OrderIdContent";

export const Route = createFileRoute("/_private/dashboard/_base/pedidos/$id/modal")({
  component: ModalOrder
});

function ModalOrder() {
  return (
    <BaseEditCreateModal title="Pedido" from="/dashboard/pedidos/$id">
      <Content />
    </BaseEditCreateModal>
  );
}
